export function calculateDiscount(
  price: number,
  discountValue: number,
  discountMode: 'PERCENT' | 'AMOUNT' | 'FIX_PRICE' | 'IDENTITY'
): number {
  if (discountMode === 'AMOUNT') {
    return Math.max(price - discountValue, 0);
  } else if (discountMode === 'FIX_PRICE') {
    return Math.min(discountValue, price);
  } else if (discountMode === 'IDENTITY') {
    return price;
  } else {
    return (price * (100 - discountValue)) / 100;
  }
}
